<app-settings-base
  title="{{'smsSettings.title' | translate}}"
  description="{{'smsSettings.text' | translate}}"
  details="{{'smsSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/sms"
  canBeTested="true">
</app-settings-base>
